import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { useAssetLookup } from "../api/useAssetLookup";
import { AssetIcon } from "../components/AssetIcon";
import { formatGameTime } from "../format/formatGameTime";
import { AssetList } from "./AssetList";
import { FindingCard } from "./FindingCard";
import type { FindingProps } from "./FindingProps";
import { iconSize } from "./iconSize";

const TITLE = msg({
  id: "finding.item_sold_soon",
  message: "{count, plural, one {# item sold} other {# items sold}} soon after buying",
});

const DETAILS = msg({
  id: "finding.item_sold_soon.details",
  message: "Selling returns half the price: {souls, plural, one {# soul} other {# souls}} lost.",
});

const SUMMARY = msg({
  id: "finding.item_sold_soon.summary",
  message: "{souls, plural, one {# soul} other {# souls}} lost",
});

// Предмет продан вскоре после покупки — потеря половины цены.
export const ItemSoldSoon = ({ finding, variant }: FindingProps<"item_sold_soon">) => {
  const { i18n } = useLingui();
  const findItem = useAssetLookup("items");
  const { sales, souls_lost: souls } = finding.params;
  return (
    <FindingCard
      code={finding.code}
      severity={finding.severity}
      variant={variant}
      icon={<AssetIcon asset={findItem(sales[0]?.item_id ?? 0)} size={iconSize(variant)} />}
      title={i18n._({ ...TITLE, values: { count: sales.length } })}
      details={i18n._({ ...DETAILS, values: { souls } })}
      summary={i18n._({ ...SUMMARY, values: { souls } })}
    >
      <AssetList
        entries={sales.map((sale) => ({
          asset: findItem(sale.item_id),
          caption: `${formatGameTime(sale.bought_at_s)} → ${formatGameTime(sale.sold_at_s)}`,
        }))}
      />
    </FindingCard>
  );
};
